import { Routes, Route, RoutesProps } from "react-router-dom";

import React, { Suspense } from "react";
import Main from "../components/Main";
import ProtectedRoute from "./ProtectedRoute";

interface ProtectedRouteProps extends RoutesProps {
  authenticationPath: string;
}

const Navigation = () => {
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));

  const SelectStation = React.lazy(
    () => import("../components/Login/SelectStation")
  );

  const GraphAnalytics = React.lazy(
    () => import("../components/GraphAnalytics/GraphAnalytics")
  );

  const ServiceRequest = React.lazy(
    () => import("../components/ServiceRequest/ServiceRequest")
  );

  const Stations = React.lazy(
    () => import("../components/Stations/AddStation")
  );

  const Reports = React.lazy(() => import("../components/Reports/Report"));

  const Alerts = React.lazy(() => import("../components/Alerts/Alert"));
  const Banner = React.lazy(() => import("../components/Banner/Banner"));

  const ForgetPassword = React.lazy(
    () => import("../components/Login/ForgotPassword")
  );
  const OTPVerification = React.lazy(
    () => import("../components/Login/OtpVerification")
  );
  const ResetPassword = React.lazy(
    () => import("../components/Login/AdminSetPassword")
  );
    const Profile = React.lazy(
    () => import("../components/Profile/Profile")
  );

  return (
    <>
      <div id="main-wraper">
        <Routes>
          <Route
            path="/login"
            element={
              <Suspense fallback={<></>}>
                <Login />
              </Suspense>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute
                {...defaultProtectedRouteProps}
                outlet={
                  <Suspense fallback={<></>}>
                    <Main />
                  </Suspense>
                }
              />
            }
          >
            <Route
              path="/forget-password"
              element={
                <Suspense fallback={<></>}>
                  <ForgetPassword />
                </Suspense>
              }
            />
            <Route
              path="/otp-verification"
              element={
                <Suspense fallback={<></>}>
                  <OTPVerification />
                </Suspense>
              }
            />
            <Route
              path="/reset-password"
              element={
                <Suspense fallback={<></>}>
                  <ResetPassword />
                </Suspense>
              }
            />
            <Route
              path="/select-station/:company_id"
              element={
                <Suspense fallback={<></>}>
                  <SelectStation />
                </Suspense>
              }
            />

            <Route
              path="/graph-analytics/:company_id"
              element={
                <Suspense fallback={<></>}>
                  <GraphAnalytics />
                </Suspense>
              }
            />
            <Route
              path="/service-request-complaint"
              element={
                <Suspense fallback={<></>}>
                  <ServiceRequest />
                </Suspense>
              }
            />

            <Route
              path="/stations"
              element={
                <Suspense fallback={<></>}>
                  <Stations />
                </Suspense>
              }
            />

            <Route
              path="/reports"
              element={
                <Suspense fallback={<></>}>
                  <Reports />
                </Suspense>
              }
            />

            <Route
              path="/alerts"
              element={
                <Suspense fallback={<></>}>
                  <Alerts />
                </Suspense>
              }
            />
            <Route
              path="/manage-banner"
              element={
                <Suspense fallback={<></>}>
                  <Banner />
                </Suspense>
              }
            />
              <Route
              path="/profile"
              element={
                <Suspense fallback={<></>}>
                  <Profile />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
